//子级router-view承载
import Center from '@/components/common/center'

//入库管理
import prep_in_list from '@/pages/prep/in/list'
//库存sku
import prep_stock_list from '@/pages/prep/stock/list'
//待出库
import prep_wait_out from '@/pages/prep/stock/wait.out'
//导入出库单
import prep_sku_import from '@/pages/prep/stock/sku.import'
//库房管理---出库管理
import prep_out from '@/pages/prep/out/list'
//导入出库单
import prep_out_import from '@/pages/prep/out/import'
//打印网页
import prep_out_print from '@/pages/prep/out/print.page'
//上传快递单
import prep_out_upload from '@/pages/prep/out/upload.express'


//废弃管理
import prep_discard_list from '@/pages/prep/discard/list'
//废弃单导入
import prep_discard_import from '@/pages/prep/discard/import'

export default [{
  path: '/prep',
  component: Center,
  redirect: '/prep/in',
  meta: {
    title: 'PREP'
  },
  children: [{
    path: '/prep/in',
    component: Center,
    redirect: '/prep/in',
    meta: {
      title: "入库包裹"
    },
    children: [{
      path: '/prep/in',
      component: prep_in_list,
      meta: {
        title: "已入库包裹"
      },
    }]
  }, {
    path: '/prep/stock',
    component: Center,
    redirect: '/prep/stock',
    meta: {
      title: "库存SKU"
    },
    children: [{
      path: '/prep/stock',
      component: prep_stock_list,
      meta: {
        title: "库存SKU"
      },
    }]
  }, {
    path: '/prep/out',
    component: Center,
    redirect: '/prep/out',
    meta: {
      title: "出库单"
    },
    children: [{
      path: '/prep/out',
      component: prep_out,
      meta: {
        title: "出库单"
      },
    }, {
      path: '/prep/out/import',
      component: prep_out_import,
      meta: {
        title: "导入出库单"
      },
    }, {
      path: '/prep/wait/out',
      component: prep_wait_out,
      meta: {
        title: "待出库区"
      },
    }, {
      path: '/prep/out/upload',
      component: prep_out_upload,
      meta: {
        title: "待出库区"
      },
    }, {
      path: '/prep/out/print',
      component: prep_out_print,
      meta: {
        title: '打印'
      },
    }]
  }, {
    path: '/prep/discard',
    component: Center,
    redirect: '/prep/discard',
    meta: {
      title: "废弃单"
    },
    children: [{

      path: '/prep/discard',
      component: prep_discard_list,
      meta: {
        title: "废弃单"
      },
    }, {
      path: '/prep/discard/import',
      component: prep_discard_import,
      meta: {
        title: "导入废弃单"
      },
    }]
  }]
}]



// WEBPACK FOOTER //
// ./src/router/module/prep.js